__turbopack_context__.v({
  "charsInfo": "FreeTextQuestion-module__cnnOpW__charsInfo",
  "enabledContent": "FreeTextQuestion-module__cnnOpW__enabledContent",
  "freeTextField": "FreeTextQuestion-module__cnnOpW__freeTextField",
});
